import React, { useState, useEffect, useCallback } from 'react'
import './App.css'
import { Link, useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import TopBarProgress from 'react-topbar-progress-indicator'
// import Header from './components/Header'
import Header from './layouts/Header'
import Header2 from './components/Header2'
import { API_URL } from './config'
import { BiSolidLocationPlus } from 'react-icons/bi'
import { BsClock } from 'react-icons/bs'

const Explore = () => {
  const history = useHistory()
  const location = useLocation()

  // 1. State Management
  const [province, setProvince] = useState(location.state?.province || '')
  const [currentEvent, setCurrentEvent] = useState([])
  const [provinces, setProvinces] = useState([])
  const [eventCategory, setEventCategory] = useState([])
  const [userData, setUserData] = useState({
    email: '',
    phone: '',
    customername: '',
  })

  const [loading, setLoading] = useState({
    spinning: 'flex',
    loadBarProgress: true,
    error: null,
  })

  // Constants from localStorage
  const customerid = localStorage.getItem('customerid')
  const accounttype = localStorage.getItem('accounttype')

  // 2. Fetch Events helper (Wrapped in useCallback to prevent effect loops)
  const fetchEvents = useCallback((prov) => {
    // Note: I added the province query back in case your API supports filtering
    const queryProv = prov ? `&province=${prov}` : ''
    const apiUrlCur = `${API_URL}/apps/kscanner/webservices.php?query=EVENTS${queryProv}`

    fetch(apiUrlCur)
      .then((res) => res.json())
      .then((result) => {
        setCurrentEvent(Array.isArray(result) ? result : [])
        setLoading((prev) => ({ ...prev, spinning: 'none' }))
      })
      .catch((err) => setLoading((prev) => ({ ...prev, error: err })))
  }, [])

  // 3. Lifecycle (useEffect)
  useEffect(() => {
    document.title = province ? `${province} - Karamale` : 'Explore - Karamale'

    // Fetch User Details if logged in
    if (customerid) {
      axios
        .get(
          `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          setUserData({
            email: response.data.email,
            phone: response.data.phone,
            customername: response.data.customername,
          })
        })
        .catch((err) => console.error('User fetch error:', err))
    }

    // Initial Data Fetches
    fetchEvents(province)

    axios.get(`${API_URL}/apps/kscanner/webservices.php?query=PROVINCES`).then((response) => {
      setProvinces(response.data)
      setLoading((prev) => ({ ...prev, loadBarProgress: false }))
    })

    axios
      .get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTCATEGORY&limit=9`)
      .then((response) => {
        setEventCategory(response.data)
      })
  }, [province, fetchEvents, customerid])

  // 4. Handlers
  const handleCategoryClick = (cat) => {
    history.push('/category', { province, category: cat })
  }

  const handleProvinceClick = (pro) => {
    setProvince(pro)
    setLoading((prev) => ({ ...prev, spinning: 'flex' }))
    fetchEvents(pro)
  }

  // 5. Date logic
  const date = new Date()
  const fulldate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`

  if (loading.error) return <div className="container mt-5">Error: {loading.error.message}</div>

  return (
    <div className="view pt-2">
      {loading.loadBarProgress && (
        <div className="col-12 text-center">
          <TopBarProgress />
          <SkeletonTheme color="#BEC3C9" highlightColor="#e2e2e2">
            <div className="container">
              <Skeleton count={5} height={20} className="mb-2" />
            </div>
          </SkeletonTheme>
        </div>
      )}

      {localStorage.getItem('customername') === null ? <Header /> : <Header />}

      <div className="container mt-0 p-0">
        <div className="row mt-5 w-100 mx-0">
          <div className="events-heading w-100 mb-3 px-3">
            <h2 className="events-title">Explore More Events</h2>
            <p className="events-subtitle">
              Explore concerts, festivals, and experiences happening in{' '}
              <strong>{province || 'your area'}</strong>.
            </p>
          </div>

          {/* Sidebar / Filters (Optional: you can re-add the Province/Category UI here) */}

          <div className="col-lg-12 middle-content house-event">
            <div className="row mt-3">
              {currentEvent.length === 0 && !loading.loadBarProgress ? (
                <div className="col-12 text-center mt-5">No events found.</div>
              ) : (
                currentEvent.map((item, index) => {
                  const posterUri = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

                  // Visibility Logic
                  const isVisible = !(item.balance < 3.5 && item.event_day > fulldate)

                  return (
                    <div
                      key={item.eventid || index}
                      className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3 d-flex"
                      style={{ display: isVisible ? 'flex' : 'none' }}
                    >
                      <Link
                        to={{
                          pathname: `/event/${item.eventid}/tickets`,
                          state: {
                            fromHome: true,
                            eventid: item.eventid,
                            eventDate: item.event_day,
                            fulldate,
                            customerid,
                            posterUri,
                            accountid: customerid,
                            accounttype,
                            customername: userData.customername,
                            email: userData.email,
                            phone: userData.phone,
                            venue: item.event_location,
                            description: item.event_des,
                            businessid: item.businessid,
                            poster: item.poster,
                            eventname: item.event_name,
                            eventday: item.eventday,
                            starttime: item.start_time,
                            endtime: item.finish_time,
                            previousPage: 'explore',
                            campaignStatus: 'running',
                            category: item.eventcategory,
                          },
                        }}
                        className="event-link w-100 text-decoration-none"
                      >
                        <div className="event-card h-100">
                          <div
                            className="event-poster"
                            style={{
                              backgroundImage: `url(${posterUri})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              height: '200px',
                            }}
                          >
                            <span className="event-date-badge">{item.eventday}</span>
                            <span className="event-time-badge">
                              <BsClock /> {item.start_time}
                            </span>
                          </div>
                          <div className="event-details p-3">
                            <h5 className="event-title text-dark">{item.event_name}</h5>
                            <p className="event-location">
                              <BiSolidLocationPlus /> {item.event_location}
                            </p>
                            <span className="event-category-badge">{item.eventcategory}</span>
                            <div
                              className="mt-3 event-description small text-secondary"
                              dangerouslySetInnerHTML={{
                                __html:
                                  item.event_des?.length > 100
                                    ? item.event_des.substr(0, 100) + '...'
                                    : item.event_des,
                              }}
                            ></div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Explore
